import ActionTypes from "actions/ActionTypes";
import api from "api";
import { ActionCreator, Dispatch } from "redux";

export const getSiteStatistic: ActionCreator<any> = () => async (
  dispatch: Dispatch
) => {
  dispatch({ type: ActionTypes.SITE_STATISTIC_REQUEST });
  try {
    const res = await api.getSiteStatistic();
    if (res?.result) {
      dispatch({
        type: ActionTypes.SITE_STATISTIC_SUCCESS,
        payload: { data: res?.result },
      });
    } else {
      dispatch({ type: ActionTypes.SITE_STATISTIC_FAIL });
    }
  } catch (e) {
    dispatch({ type: ActionTypes.SITE_STATISTIC_FAIL });
  }
};
